<div class="container-content container-resultsView">
    <aside>
        <pq-filter-menu [profile]="profile"
                        [sourceTypes]="sourceTypes"
                        [suppressSourceTypes]="suppressSourceTypes"
                        [limitTo]="limitTo"
                        [suppressLimitTo]="suppressLimitTo"
                        [currencyFilter]="isCurrFilterApplied">
        </pq-filter-menu>
    </aside>

    <div class="container-resultsContent">
        <pq-loading [loading]="loading" [error]="error" [msg]="msg"></pq-loading>

        <div class="container-noResults" role="alert" *ngIf="loading == false && error == false && hasResults === false">
            <h1>Sorry, no results were found.</h1>

            <h2>Search Suggestions:</h2>
            <ul>
                <li>Check your spelling.</li>
                <li>Try more general words.</li>
                <li>Try different words that mean the same thing.</li>
            </ul>
        </div>

        <div *ngIf="loading == false && error == false && hasResults === true">
            <h1 aria-live="polite">
              Showing {{displayTotal}} results for "{{term}}"{{additionalMessage}}
            </h1>
            <div *ngIf="hasSpellSuggestions == true" class="container-didYouMean">
              <p>Did you mean: <a [routerLink]="[resultsUrl]" [queryParams]="{ 'query': spellSuggestions }">{{spellSuggestions}}</a></p>
            </div>
            <pq-document-list *ngIf="!isImageResults"
              [page]="page"
              [profile]="profile"
              [topResearchTopic]="topResearchTopic"
              [docResults]="results"
              [images]="imageRow"
              [relatedTopicsData]="relatedTopicsData"
              [relatedSearchTitle]="relatedSearchTitle"
              [relatedSearches]="relatedSearches">
            </pq-document-list>

            <pq-image-list *ngIf="isImageResults"
              [imageResults]="results"
              [profile]="profile">
            </pq-image-list>

            <pq-pagination
              [total]="total"
              [currentPage]="page"
              [profile]="profile"
              [queryParam]="queryParams"
              [numberPerPage]="numberPerPage">
            </pq-pagination>

        </div>
    </div>

</div>


